/* eslint-disable no-unused-vars */
/* eslint-disable valid-jsdoc */
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import {
  INVALIDATE_USERS,
  INVALIDATE_DOSSIER,
  INVALIDATE_CLIENT,
  INVALIDATE_FOURNISSEURS,
  INVALIDATE_PRODUITS,
  INVALIDATE_SALARIES,
  INVALIDATE_OPERATEURS,
  INVALIDATE_COMPTE_PAIEMENT,
  INVALIDATE_COLLABORATEUR,
  INVALIDATE_FACTURE,
  INVALIDATE_CODE_JOURNAL,
  INVALIDATE_ECRITURE,
  INVALIDATE_LIVRE_JOURNAL,
  INVALIDATE_OCR,
  INVALIDATE_ROLES,
  INVALIDATE_PLAN_COMPTABLE,
  INVALIDATE_DETTES,
  INVALIDATE_CREANCES,
  INVALIDATE_VENTES,
  INVALIDATE_DEPENSES,
  INVALIDATE_TRANSACTIONS,
  INVALIDATE_PERMISSIONS,
  INVALIDATE_BILAN_COMPTABLE,
  INVALIDATE_TIERS,
  INVALIDATE_CURRENT_USER,
  INVALIDATE_PAIEMENT_CREANCES,
  INVALIDATE_DETTES_CLIENT,
  INVALIDATE_CREANCES_CLIENT,
  INVALIDATE_EXPERT_DOSSIERS,
  INVALIDATE_DOSSIER_PARTAGE,
} from './invalidationTags';
import {
  logout,
  setAccessToken,
} from 'redux/features/userSliceWithTokenValidation';
import { DEFAULT_API, REFRESH_TOKEN } from 'routes/api/endpoints';

const baseQuery = fetchBaseQuery({
  baseUrl: DEFAULT_API,
  prepareHeaders: (headers, { getState }) => {
    const state = getState();
    // CORRECTION : lire accessToken en priorite (mis a jour par setAccessToken
    // apres un refresh). Fallback sur currentUser.access pour compat.
    const accessToken =
      state.auth?.accessToken ||
      (state.auth && state.auth.currentUser
        ? state.auth.currentUser.access
        : null);

    if (accessToken) {
      return headers.set('Authorization', `Bearer ${accessToken}`);
    }
    return headers;
  },
});

/**
 *=====================================================
 *
 * Verification de la validite du token
 *
 * ====================================================
 */
const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    const authState = api.getState().auth;
    const refreshToken = authState?.refreshToken;

    if (refreshToken) {
      const refreshResult = await baseQuery(
        {
          url: REFRESH_TOKEN,
          method: 'POST',
          body: JSON.stringify({ refresh: refreshToken }),
          headers: {
            'Content-Type': 'application/json',
          },
        },
        api,
        extraOptions
      );

      if (refreshResult.data) {
        // CORRECTION : SimpleJWT retourne { access, refresh }, pas { accessToken }
        const newAccessToken = refreshResult.data.access || refreshResult.data.accessToken;
        if (newAccessToken) {
          // Mettre a jour le token dans le store Redux
          api.dispatch(setAccessToken(newAccessToken));

          // Mettre a jour aussi currentUser.access pour que prepareHeaders
          // utilise le nouveau token meme si accessToken n est pas lu
          if (authState?.currentUser) {
            api.dispatch({
              type: 'auth/setCredentials',
              payload: { ...authState.currentUser, access: newAccessToken, refresh: refreshToken },
            });
          }

          // Reessayer la requete originale avec le nouveau token
          result = await baseQuery(args, api, extraOptions);
        } else {
          api.dispatch(logout());
        }
      } else {
        // If token refresh fails, log out
        api.dispatch(logout());
      }
    } else {
      // No refresh token available, log out
      api.dispatch(logout());
    }
  }

  return result;
};

/**
 *=====================================================
 *
 * OPTION1: Base api avec validation du token
 *
 * ====================================================
 */
export const rxdApi = createApi({
  baseQuery: baseQueryWithReauth,
  refetchOnReconnect: true,
  keepUnusedDataFor: 300,
  reducerPath: 'path',
  endpoints: () => ({}),
});
/**
 *=====================================================
 *
 * OPTION1: Base api avec sans validation du token
 *
 * ====================================================
 */
// export const rxdApi = createApi({
//     baseQuery: fetchBaseQuery({ baseUrl:DEFAULT_API }),
//     refetchOnReconnect: true,
//     keepUnusedDataFor: 86400,
//     reducerPath: "path",
//     endpoints: () => ({}),
// });

export const ApiMananger = rxdApi.enhanceEndpoints({
  addTagTypes: [
    INVALIDATE_USERS,
    INVALIDATE_DOSSIER,
    INVALIDATE_CLIENT,
    INVALIDATE_FOURNISSEURS,
    INVALIDATE_PRODUITS,
    INVALIDATE_SALARIES,
    INVALIDATE_OPERATEURS,
    INVALIDATE_COMPTE_PAIEMENT,
    INVALIDATE_COLLABORATEUR,
    INVALIDATE_FACTURE,
    INVALIDATE_CODE_JOURNAL,
    INVALIDATE_ECRITURE,
    INVALIDATE_LIVRE_JOURNAL,
    INVALIDATE_OCR,
    INVALIDATE_ROLES,
    INVALIDATE_PLAN_COMPTABLE,
    INVALIDATE_DETTES,
    INVALIDATE_CREANCES,
    INVALIDATE_VENTES,
    INVALIDATE_DEPENSES,
    INVALIDATE_TRANSACTIONS,
    INVALIDATE_PERMISSIONS,
    INVALIDATE_BILAN_COMPTABLE,
    INVALIDATE_TIERS,
    INVALIDATE_CURRENT_USER,
    INVALIDATE_PAIEMENT_CREANCES,
    INVALIDATE_DETTES_CLIENT,
    INVALIDATE_CREANCES_CLIENT,
    INVALIDATE_EXPERT_DOSSIERS,
    INVALIDATE_DOSSIER_PARTAGE,
  ],
});
